export const COMMENT_TYPE_PROCESS = 'PROCESS';
export const COMMENT_TYPE_ALL = 'ALL';
